import React, { useState, useContext, useRef, useEffect } from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { SurveyContext } from "../../store/survey-context";

export default function PlacesWrapper(props) {
  const { showNav } = useContext(SurveyContext);
  const { question } = props;
  // function constructor(props) {
  //   super(props);
  //   const { question } = this.props;
  //   this.state = {
  //     address: question.value ? question.value : "",
  //     selectedAddress: question.value ? question.value : "",
  //   };
  //   this.placesRef = React.createRef();
  //   this.inputEl = React.createRef();
  // }
  const placesRef = useRef();
  const inputEl = useRef();

  const [address, setAddress] = useState(question.value ? question.value : "");
  const [selectedAddress, setSelectedAddress] = useState(
    question.value ? question.value : ""
  );

  const prevValue = useRef(props.value);

  useEffect(() => {
    const btn = document.querySelector(".sv_clear");
    btn?.addEventListener("click", () => {
      setAddress("");
    });
  }, []);

  useEffect(() => {
    if (prevValue.current === props.value) return;
    if (!props.value) {
      setAddress("");
    }

    // restore the value, when showing the nav
    if (
      showNav &&
      typeof question.value === "string" &&
      question.value !== address
    ) {
      setAddress(props.question.value);
      inputEl?.current.classList.add("filled-in");
    }
  }, [props.value, showNav, question.value, address, props.question.value]);

  function onChange(address) {
    setAddress(address);
  }

  function onSelect(address, placeId, suggestion) {
    // Do something with address and placeId and suggestion
    if (placeId !== null) {
      const { question } = props;
      setAddress(address);
      setSelectedAddress(address);
      question.value = address;
    }
    inputEl?.current.blur();
  }

  function onBlur(e, suggestions) {
    const { question } = props;
    // change the value to be the one stored in question.value (to replace the value not picked from autocomplete)
    const inputValue = e.target.value.trim();
    const foundSuggestion = suggestions.filter(
      (s) =>
        s.description.localeCompare(inputValue, undefined, {
          sensitivity: "base",
        }) === 0
    );

    if (
      inputValue.localeCompare(selectedAddress, undefined, {
        sensitivity: "base",
      }) === 0
    ) {
      // no change - but might be trimmed
      setAddress(inputValue);
    } else if (foundSuggestion.length) {
      setAddress(foundSuggestion[0].description);
      setSelectedAddress(foundSuggestion[0].description);

      question.value = foundSuggestion[0].description;
    } else if (question.value && inputValue !== question.value) {
      setAddress(question.value);
    } else {
      question.value = null;
      setAddress("");
      inputEl?.current.classList.remove("filled-in");
    }

    placesRef.current?.clearSuggestions();
  }

  const cssClasses = {
    root: "form-group",
    input: "form-control",
    autocompleteContainer: "autocompleteContainer",
  };

  const searchOptions = {
    //location: new window.google.maps.LatLng(-34, 151),
    //radius: 2000,
    types: ["(cities)"],
  };

  return (
    <PlacesAutocomplete
      classNames={cssClasses}
      value={address}
      onChange={onChange.bind(this)}
      onSelect={onSelect.bind(this)}
      searchOptions={searchOptions}
      shouldFetchSuggestions={address.length > 0}
      ref={placesRef}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <div className="input-wrapper" role="status">
            <input
              {...getInputProps({
                placeholder: "",
                className: "location-search-input sv_q_text_root",
              })}
              onBlur={(e) => onBlur.bind(this)(e, suggestions)}
              id={question.inputId}
              ref={inputEl}
            />
          </div>
          <div className="autocomplete-dropdown-container" role="listbox">
            {loading && <div></div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? "suggestion-item--active"
                : "suggestion-item";
              return (
                <div
                  key={suggestion.placeId}
                  {...getSuggestionItemProps(suggestion, {
                    className,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
}
